import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { DataService } from 'src/app/services/data.service';
import { AddSubjectComponent } from './add-subject/add-subject.component';
import { APPS } from 'src/app/dummy/app';
import { orderBy } from 'src/app/services/mapping.service';
import { AuthService } from 'src/app/auth/auth.service';
import { LazyData } from 'src/app/stores/administrator/lazyData.store';
import { List } from 'src/app/stores/administrator/list.store';
import { AuthStore } from 'src/app/stores/auth/auth.store';

@Component({
  selector: 'app-subject',
  templateUrl: './subject.component.html',
  styleUrls: ['./subject.component.scss']
})
export class SubjectComponent implements OnInit {
  tabs = []
  TYPE: any;
  PROGRAM_TYPES: Array<any> = [];

  constructor(
    private auth: AuthStore,
    public store: LazyData,
    public list: List,
    public rotue: ActivatedRoute,
    public ds: DataService,
    public dialog: MatDialog) { }

  create(event) {
    const dialogRef = this.dialog.open(AddSubjectComponent, {
      data: this.TYPE,
      panelClass: 'register-test-overlay-panel',
      width: '30vw',
      height: '100vh',
      disableClose: false,
      role: 'dialog',
    });
    dialogRef.updatePosition({ top: '0', right: '0', bottom: '0' });
    dialogRef.afterClosed().subscribe(result => { });
  }

  async ngOnInit() {
    await this.auth.fetchEnvironment()
    this.PROGRAM_TYPES =orderBy(await this.list.fetchList(this.ds.adprogramCollectRef()),"order")
    this.tabs = this.PROGRAM_TYPES.map(m => ({ path: `/subjects/${m.key}`, label: m.name }))
    this.rotue.params.subscribe(params => {
      const { id } = params;
      this.TYPE = this.PROGRAM_TYPES.filter(m => m.key === id)[0]
      this.store.fetchData(this.ds.subjectRef(ref => ref
        .where("programKey", "==", id)
        .orderBy('page_key')
        .limit(APPS.SIZE)))
    })
  }

  onScroll() {
    const { lastVisible } = this.store;
    if (!lastVisible) return;
    this.store.fetchMore(this.ds.subjectRef(ref => ref
      .where("programKey", "==", this.TYPE)
      .orderBy('page_key')
      .startAfter(lastVisible.page_key)
      .limit(APPS.SIZE)))
  }

  ngOnDestroy() {
    this.store.dispost();
  }
}
